import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import StudentManagement from './StudentManagement';
import TeacherManagement from './TeacherManagement';
import axios from 'axios';
import TeacherApprovals from './TeacherApprovals';
import { host } from '../../api/ApiCalls';
import Transactions from './Transactions';
import AdminWithdrawRequests from './AdminWithdrawRequests';

function DashboardAdmin() {
  const [component, setComponent] = useState('AdminDashboard');
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalStudents: 0,
    totalTeachers: 0,
    totalCourses: 0,
    totalRevenue: 0,
  });
  const [todaysClasses, setTodaysClasses] = useState([]);
  const [upcomingClasses, setUpcomingClasses] = useState([]);
  const [studentGrowth, setStudentGrowth] = useState([]);
  const [teacherGrowth, setTeacherGrowth] = useState([]);
  const [courseGrowth, setCourseGrowth] = useState([]);
  const [revenueOverview, setRevenueOverview] = useState([]);
  const [activities, setActivities] = useState([]);
  const [studentGrowthData, setStudentGrowthData] = useState([]);
  const [teacherGrowthData, setTeacherGrowthData] = useState([]);
  const [courseGrowthData, setCourseGrowthData] = useState([]);
  const [revenueOverviewData, setRevenueOverviewData] = useState([]);

  const [students, setStudents] = useState([]);
  const [studentStats, setStudentStats] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [teacherStats, setTeacherStats] = useState([]);

  const [unapprovedTeachers, setUnapprovedTeachers] = useState([]);
  const [transactions, setTransactions] = useState([]);

   const [requests, setRequests] = useState([]);

  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];


  const formatDateKey = (item) => {
  const { year, month } = item._id;
  return new Date(year, month - 1); // JS months are 0-based
};

 

//   const formatGrowthData = (rawData) => {
//   const data = [['Month', 'Students']];
//   rawData
//     .sort((a, b) => a._id - b._id) // ✅ Sort by month number
//     .forEach((item) => {
//       const month = monthNames[item._id - 1] || 'Unknown';
//       data.push([month, item.count]);
//     });
//     console.log('Formatted Growth Data:', data); // 🪵 Debug this
//   return data;
// };

const formatGrowthData = (rawData) => {
  const data = [['Month', 'Students']];
  rawData.forEach((item) => {
    const { year, month } = item._id;
    const date = new Date(year, month - 1); // month is 0-indexed
    data.push([date, item.count]);
  });
  return data;
};



  // const formatTeacherGrowthData = (rawData) => {
  //   const data = [['Month', 'Teachers']]; // ✅ Google Chart format
  //   rawData.forEach((item) => {
  //     const month = monthNames[item._id - 1] || 'Unknown';
  //     data.push([month, item.count]);
  //   });
  //   console.log('Formatted Teacher Growth Data:', data); // 🪵 Debug this
  //   return data;
  // };

 const formatTeacherGrowthData = (rawData) => {
  const data = [['Month', 'Teachers']];
  rawData.forEach((item) => {
    const { year, month } = item._id;
    const date = new Date(year, month - 1); // month is 0-indexed
    data.push([date, item.count]);
  });
  return data;
};



// const formatTeacherGrowthData = (rawData) => {
//   const data = [['Month', 'Teachers']];
//   rawData
//     .filter((item) => item._id && item._id.year !== undefined && item._id.month !== undefined)
//     .sort((a, b) => {
//       const aDate = new Date(a._id.year, a._id.month - 1);
//       const bDate = new Date(b._id.year, b._id.month - 1);
//       return aDate - bDate;
//     })
//     .forEach((item) => {
//       const { year, month } = item._id;
//       const label = `${monthNames[month - 1]} ${year}`;
//       data.push([label, item.count]);
//     });
//   return data;
// };




  // const formatRevenueData = (rawData) => {
  //   const data = [['Month', 'Revenue']];
  //   rawData.forEach((item) => {
  //     const month = monthNames[item._id - 1];
  //     data.push([month, item.revenue]);
  //   });
  //   return data;
  // };

  const formatRevenueData = (rawData) => {
  const data = [['Month', 'Revenue']];
  rawData.forEach((item) => {
    data.push([formatDateKey(item), item.revenue]);
  });
  return data;
};


  // const formatCourseGrowthData = (rawData) => {
  //   const data = [['Month', 'Courses']]; // ✅ Google Chart format
  //   rawData.forEach((item) => {
  //     const month = monthNames[item._id - 1] || 'Unknown';
  //     data.push([month, item.count]);
  //   });
  //   console.log('Formatted Course Growth Data:', data); // 🪵 Debug this
  //   return data;
  // };

  const formatCourseGrowthData = (rawData) => {
  const data = [['Month', 'Courses']];
  rawData.forEach((item) => {
    data.push([formatDateKey(item), item.count]);
  });
  return data;
};



  //   Admin Dashboard Functionality
  useEffect(() => {
    const fetchData = async () => {
      // setLoading(true);
      try {
        const res = await axios.get(
          `${host}/api/admin/stats/dashboard`
        );

        setStats({
          totalStudents: res.data.totalStudents,
          totalTeachers: res.data.totalTeachers,
          totalCourses: res.data.totalCourses,
          totalRevenue: res.data.totalRevenue,
        });

        setTodaysClasses(res.data.todaysClasses || []);
        setUpcomingClasses(res.data.upcomingClasses || []);
        setStudentGrowth(res.data.studentsGrowthData || []);
        setTeacherGrowth(res.data.teacherGrowthData || []);
        setCourseGrowth(res.data.courseGrowthData || []);
        setRevenueOverview(res.data.revenueOverview || []);
        setActivities(res.data.formatted || []);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching admin stats:', error);
        setLoading(false);
      }
    };

    const intervalId = setInterval(fetchData, 5000); // 🔁 every 10 seconds

    return () => clearInterval(intervalId); // clear when component unmounts
  }, []);

  useEffect(() => {
    if (!loading) {
      if (studentGrowth && studentGrowth.length > 0) {
        const formatted = formatGrowthData(studentGrowth);
        setStudentGrowthData(formatted);
        console.log('✅ studentGrowthData:', formatted);
      } else {
        console.log('⚠️ studentGrowth empty ya undefined');
      }

      if (teacherGrowth && teacherGrowth.length > 0) {
        const formatted = formatTeacherGrowthData(teacherGrowth);
        setTeacherGrowthData(formatted);
        console.log('✅ teacherGrowthData:', formatted);
      } else {
        console.log('⚠️ teacherGrowth empty ya undefined');
      }

      if (revenueOverview && revenueOverview.length > 0) {
        const formatted = formatRevenueData(revenueOverview);
        setRevenueOverviewData(formatted);
        console.log('✅ revenueOverviewData:', formatted);
      } else {
        console.log('⚠️ revenueOverview empty ya undefined');
      }

      if (courseGrowth && courseGrowth.length > 0) {
        const formatted = formatCourseGrowthData(courseGrowth);
        setCourseGrowthData(formatted);
        console.log('✅ courseGrowthData:', formatted);
      } else {
        console.log('⚠️ courseGrowth empty ya undefined');
      }
    }
  }, [loading, studentGrowth, revenueOverview]);

  // Student Management Functionality
  useEffect(() => {
    const fetchStudents = async () => {
      try {
        // setLoading(true);
        const res = await axios.get(
          `${host}/api/admin/allStudents`
        ); // 👈 update with your API URL
        setStudents(res.data.students); // data format from controller
        setStudentStats(res.data.stats); // data format from controller
        // setLoading(false);
      } catch (err) {
        console.error('Error fetching students:', err);
        // setLoading(false);
      }
    };

    const intervalId = setInterval(fetchStudents, 5000); // 🔁 every 10 seconds

    return () => clearInterval(intervalId); // clear when component unmounts
  }, []);

  // Teacher Management Functionality
  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        // setLoading(true);
        const res = await axios.get(
          `${host}/api/admin/allTeachers`
        ); // 👈 update with your API URL
        setTeachers(res.data.teachers); // data format from controller
        setTeacherStats(res.data.stats); // data format from controller
        // setLoading(false);
      } catch (err) {
        console.error('Error fetching teachers:', err);
        // setLoading(false);
      }
    };

    const intervalId = setInterval(fetchTeachers, 5000); // 🔁 every 10 seconds

    return () => clearInterval(intervalId); // clear when component unmounts
  }, []);

  // Teacher Approvals Functionality
  useEffect(() => {
    const fetchTeacherApprovals = async () => {
      try {
        // setLoading(true);
        const res = await axios.get(
          `${host}/api/admin/unverifiedTeachers`
        );
        setUnapprovedTeachers(res.data.teachers); // data format from controller
        // setLoading(false);
      } catch (err) {
        console.error('Error fetching teacher approvals:', err);
        // setLoading(false);
      }
    };

    const intervalId = setInterval(fetchTeacherApprovals, 5000); // 🔁 every 10 seconds

    return () => clearInterval(intervalId); // clear when component unmounts
  }, []);

  // Transactions
  useEffect(() => {
      const fetchTransactions = async () => {
        try {
          const res = await axios.get(`${host}/api/admin/transactions`); // Adjust route as needed
          setTransactions(res.data);
        } catch (err) {
          console.error('Failed to fetch transactions:', err);
        } 
      };
  
      fetchTransactions();
    }, []);

    // withdraw requests

   
    
      const fetchWithdrawRequests = async () => {
        try {
          const token = JSON.parse(localStorage.getItem("academiaHubToken"));
          const res = await axios.get(`${host}/api/admin/withdraw-requests`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setRequests(res.data.requests);
        } catch (err) {
          // toast.error("Failed to load withdraw requests.");
          console.error('Failed to fetch withdraw requests:', err);
        }
      };
       useEffect(() => {
        fetchWithdrawRequests();

        const intervalId = setInterval(fetchWithdrawRequests, 5000); // 🔁 every 10 seconds

    return () => clearInterval(intervalId); // clear when component unmounts
      }, []);

  return (
    <>
      {component === 'AdminDashboard' ? (
        <AdminDashboard
          setComponent={setComponent}
          stats={stats}
          loading={loading}
          todaysClasses={todaysClasses}
          upcomingClasses={upcomingClasses}
          studentGrowth={studentGrowth}
          teacherGrowth={teacherGrowth}
          teacherGrowthData={teacherGrowthData}
          setTeacherGrowthData={setTeacherGrowthData}
          revenueOverview={revenueOverview}
          activities={activities}
          studentGrowthData={studentGrowthData}
          revenueOverviewData={revenueOverviewData}
          setStudentGrowthData={setStudentGrowthData}
          setRevenueOverviewData={setRevenueOverviewData}
          courseGrowthData={courseGrowthData}
          setCourseGrowthData={setCourseGrowthData}
          courseGrowth={courseGrowth}
          setCourseGrowth={setCourseGrowth}
        />
      ) : component === 'TeacherManagement' ? (
        <TeacherManagement
          component={component}
          setComponent={setComponent}
          teachers={teachers}
          stats={teacherStats}
          setTeachers={setTeachers}
        />
      ) : component === 'StudentManagement' ? (
        <StudentManagement
          component={component}
          setComponent={setComponent}
          students={students}
          stats={studentStats}
          setStudents={setStudents}
        />
      ) : component === 'TeacherApprovals' ? (
        <TeacherApprovals
          component={component}
          setComponent={setComponent}
          unapprovedTeachers={unapprovedTeachers}
          setUnapprovedTeachers={setUnapprovedTeachers}
        />
      ) : component === 'Transactions' ? (
        <Transactions
          component={component}
          setComponent={setComponent}
          transactions={transactions}
          setTransactions={setTransactions}
        />
      ) : component === 'WithdrawRequests' ? (
        <AdminWithdrawRequests
          component={component}
          setComponent={setComponent}
          requests={requests}
          setRequests={setRequests}
          fetchWithdrawRequests={fetchWithdrawRequests}
        />
      ) : (
        <div className="text-center text-gray-500">Select a component</div>
      )}
    </>
  );
}

export default DashboardAdmin;
